import { useRef, useEffect, useMemo } from 'react';
import { debounce } from 'underscore';

type CallbackFunction = (params?: any) => void;

export const useDebouncedCallback = (callback: CallbackFunction, waitTime = 700) => {
  const ref = useRef<CallbackFunction>();

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  const debouncedCallback = useMemo(() => {
    const func = (...args) => {
      ref.current?.(...args);
    };

    return debounce(func, waitTime);
  }, [waitTime]);

  return debouncedCallback;
};
